import { useTheme } from '@mui/material';
import { useIntl } from 'react-intl';

import { useAppSelector, useFeatureFlagSplit } from '@verantos-dev/app-state-base';
import {
  selectResearchAssistantIsReady,
  selectResearchAssistantIsWaitingForResponse,
  selectResearchAssistantMessages,
  selectResearchAssistantModel,
} from '@verantos-dev/app-state-research-assistant';
import { useAuth } from '@verantos-dev/core-auth';

import { useResearchAssistantPromptState } from './useResearchAssistantPromptState';
import { useScrollMessageIntoView } from './useScrollMessageIntoView';

export const useResearchAssistantChatWindow = () => {
  const isResearchAssistantVersionSelectorEnabled = useFeatureFlagSplit(
    'multivariant_research_assistant_version_selector'
  );

  const intl = useIntl();
  const theme = useTheme();
  const {
    user: { isInternalUser },
  } = useAuth();

  const isWaitingForResponse = useAppSelector(selectResearchAssistantIsWaitingForResponse);
  const isReady = useAppSelector(selectResearchAssistantIsReady);
  const model = useAppSelector(selectResearchAssistantModel);
  const messages = useAppSelector(selectResearchAssistantMessages);

  const { chatWindowRef, messagesEndRef } = useScrollMessageIntoView();
  const { userPrompt, onModelChange, onUserPromptChange, sendUserPrompt } =
    useResearchAssistantPromptState();

  return {
    intl,
    theme,
    chatWindowRef,
    model,
    onModelChange,
    userPrompt,
    onUserPromptChange,
    sendUserPrompt,
    messages,
    isWaitingForResponse,
    isReady,
    messagesEndRef,
    shouldShowVersionSelector: isResearchAssistantVersionSelectorEnabled && isInternalUser,
  };
};
